export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9420.d70dbb75.jpg";